import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Spinner } from '@nike/podium';
import { useUser } from '~/atoms/hooks/useUser';
import DropdownMenuWrapper from '../DropdownMenuWrapper';
import { useSetAtom } from 'jotai';
import { userPreferencesModalOpenAtom } from '~/atoms/userPreferences';
import UserPreferencesModal from '../modals/UserPreferencesModal';
import { menuAvatar as baseMenuAvatar } from '~/constants/menuConstants';
const AvatarWrapper = () => {
    const { user, userLoadingState } = useUser();
    const openPreferences = useSetAtom(userPreferencesModalOpenAtom);
    // Start from constants, then inject the open handler for Profile
    const menuAvatar = baseMenuAvatar.map((item) => {
        if (item.id !== 'My Account' || !item.group)
            return item;
        return {
            ...item,
            group: item.group.map((g) => g.id === 'Profile' ? { ...g, onClick: () => openPreferences(true) } : g)
        };
    });
    if (userLoadingState !== 'hasData')
        return _jsx(Spinner, {});
    if (!user)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx("nav", { className: "z-10 rounded-full header-height", children: _jsx("ul", { className: "flex h-12 items-center", children: _jsx("li", { children: _jsx(DropdownMenuWrapper, { menu: menuAvatar, children: _jsx(Avatar, { "data-testid": "avatar", initials: getInitials(user), size: "medium", alt: user?.firstName || 'User', "aria-hidden": "true" }) }) }) }) }), _jsx(UserPreferencesModal, {})] }));
};
function getInitials(user) {
    const firstInitial = user.firstName?.trim().charAt(0) || '';
    const lastInitial = user.lastName?.trim().charAt(0) || '';
    const initials = (firstInitial + lastInitial).toUpperCase();
    return initials || '';
}
export default AvatarWrapper;
